<script lang="ts">
const effectOff = -18
</script>
<template>
  <div class="arrow-wrapper" :style="styleTranslateArrowEffect">
    <div class="arrow" />
  </div>
</template>
<script setup lang="ts">
// @ts-ignore
import { spring } from 'vue3-spring';

interface Props {
  index: number;
  visible?: boolean;
}

const props = defineProps({
  index: null,
  visible: { type: Boolean, default: false }
});

// arrow effect

const translateArrow = ref<number>(effectOff);

const translateEffect = spring(translateArrow, {
  damping: 13,
  stiffness: 105,
  mass: 1,
  from: translateArrow.value,
});

const styleTranslateArrowEffect = computed(() => {
  // const opacity = 1 - translateEffect.value / effectOff;
  return {
    transform: `translateY(${translateEffect.value}rem)`,
  };
});

watch(
  () => props.visible,
  (b) => {
    if (!b) {
      translateArrow.value = effectOff;
    } else {
      translateArrow.value = 0;
    }
  }
);
</script>
<style lang="scss" scoped>
.arrow-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
}
.arrow {
  position: absolute;
  bottom: -0.3rem;
  left: 0;
  width: 4rem;
  height: 4rem;
  margin-left: -2rem;
  transform: rotate(45deg);
  border-radius: 0.3rem;
  background-color: var(--color_neutral_100);
}
</style>
